export default {
  'system.title': 'System Requirements',
  'system.required':
    'This service supports the following operating systems:<br />' +
    'iOS / iPadOS 14.1 or later<br />' +
    'Android 11 or later (stock operating system)<br />' +
    '*Devices with customized operating systems may not be supported.',
} as Record<string, string>;
